import { EdgelessLinkToolButton } from './toolbar/link-tool-button';

export function effects() {
  customElements.define('edgeless-link-tool-button', EdgelessLinkToolButton);
}
